/**
 * Fetch all users via tRPC (admin only).
 * Returns snake_case User[].
 */

import { useQuery } from "@tanstack/react-query";
import { trpc } from "../trpc";

export function useUsersQuery(enabled: boolean) {
	const utils = trpc.useUtils();
	return useQuery({
		queryKey: ["users"],
		queryFn: () => utils.user.list.fetch(),
		enabled,
	});
}
